import { c as _c } from "react/compiler-runtime";
import { toast } from '@systemeio/ui';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import TransLoco from 'shared/components/trans-loco';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useRevalidateModules } from 'shared/hooks/use-revalidate-modules';
import useUser from 'shared/hooks/use-user';
import { GOOGLE_INTEGRATIONS_PATH } from '../api';
import { CalendarAccessRoleEnum, CalendarInterface } from '../types';
export const useCalendars = () => {
  const $ = _c(14);
  const {
    user
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const {
    revalidateModules
  } = useRevalidateModules();
  let t0;
  if ($[0] !== revalidateModules || $[1] !== t) {
    t0 = {
      method: RequestMethodsEnum.get,
      accessDeniedHandler: () => {
        toast.error(<TransLoco t={t} i18nKey="dashboard.integrations.google_calendar.disconnected_info" components={{
          a: <LinkWithoutPrefetch href="/integrations" className="primary-link" />
        }} />);
        revalidateModules([RequestModuleEnum.GoogleIntegrations]);
      }
    };
    $[0] = revalidateModules;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    fetcher: fetchIntegrations
  } = useFetch(t0);
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.patch
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    fetcher: patchFetcher
  } = useFetch(t1);
  let t2;
  if ($[4] !== user) {
    t2 = () => {
      if (!user) {
        return;
      }
      return [`${GOOGLE_INTEGRATIONS_PATH}/calendars?minAccessRole=${CalendarAccessRoleEnum.FreeBusyReader}`, RequestModuleEnum.GoogleIntegrationsCalendars];
    };
    $[4] = user;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    data,
    mutate,
    isLoading
  } = useControlledSwr(t2, fetchIntegrations, undefined);
  let t3;
  if ($[6] !== patchFetcher) {
    t3 = async (calendarId, integrationId, changes) => {
      await patchFetcher(`${GOOGLE_INTEGRATIONS_PATH}/calendars/${encodeURIComponent(calendarId)}?integrationId=${integrationId}`, changes);
    };
    $[6] = patchFetcher;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const patchCalendar = t3;
  const hasGoogleCalendars = data ? data.length > 0 : false;
  let t4;
  if ($[8] !== data || $[9] !== hasGoogleCalendars || $[10] !== isLoading || $[11] !== mutate || $[12] !== patchCalendar) {
    t4 = {
      data,
      mutate,
      patchCalendar,
      hasGoogleCalendars,
      isLoading
    };
    $[8] = data;
    $[9] = hasGoogleCalendars;
    $[10] = isLoading;
    $[11] = mutate;
    $[12] = patchCalendar;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};